import { Box, Typography, Button } from "@mui/material";
import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";
import { SuggestionCard } from "./suggestion-card";
import ReadMoreIcon from "@mui/icons-material/ReadMore";
import { useChatContext } from "../../chat";

interface SuggestionsProps {
  onShowAll: () => void;
}

export const SuggestionsList = ({ onShowAll }: SuggestionsProps) => {
  const { suggestions, handleSuggestionClick } = useChatContext();

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 1,
        padding: 1,
        maxWidth: "100%",
        overflowX: "auto",
        minHeight: suggestions.length > 0 ? "auto" : "2rem",
      }}
    >
      {suggestions.map((suggestion, index) => (
        <SuggestionCard
          key={index}
          suggestion={suggestion}
          handleSuggestionClick={handleSuggestionClick}
        />
      ))}
      {suggestions.length > 0 && (
        <Button
          variant="outlined"
          onClick={onShowAll}
          endIcon={<ReadMoreIcon />}
          sx={{
            padding: "5px 15px",
            borderRadius: "20px",
            textTransform: "none",
            display: "flex",
            alignItems: "center", // aligns text and icon vertically
            gap: 0.5, // optional: small space between text and icon
          }}
        >
          <Typography variant="body2">View all</Typography>
        </Button>
      )}

      {!suggestions.length && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            color: "gray",
            padding: "5px 5px",
          }}
        >
          <LightbulbOutlinedIcon
            sx={{
              marginRight: "8px",
              fontSize: "20px",
            }}
          />
          <Typography variant="body2">
            Suggestions will appear here...
          </Typography>
        </Box>
      )}
    </Box>
  );
};
